import React, { useEffect, useRef, useState } from "react";
import {
  DashboardCompanyList,
  siteDashboardDetails,
  siteDashboardList,
  superDashboard,
} from "../../redux/api/dummyJson";
import { useNavigate } from "react-router-dom";
import { get } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import VideocamIcon from "@mui/icons-material/Videocam";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

const SuperAdminDashboard = () => {
  const givenpermissions = JSON.parse(
    localStorage.getItem("user_permission") ?? "[]",
  );
  const navigate = useNavigate();
  const [dashboardList, setDashboardList] = useState({});
  const [siteList, setSiteList] = useState({ name: "", list: [] });

  const companyRef = useRef();
  const siteRef = useRef();
  const detailsRef = useRef();

  const [show, setShow] = useState({
    company: false,
    siteDetails: false,
  });

  useEffect(() => {
    if (show.company && companyRef.current) {
      companyRef.current.focus();
    }
  }, [show.company]);

  useEffect(() => {
    if (show.siteDetails && detailsRef.current) {
      detailsRef.current.focus();
    }
  }, [show.siteDetails]);

  const handleNavigate = (id) => {
    switch (id) {
      case 1:
        navigate("/admin");
        break;
      case 2:
        setShow((prev) => ({ ...prev, company: !prev.company }));
        break;
      case 3:
        setShow((prev) => ({ ...prev, company: false, siteDetails: true }));
        break;
      default:
        break;
    }
  };

  const navigationHandler = (route, routeProb) => {
    if (route) navigate(route, { state: routeProb ?? {} });
  };

  const getDashboard = () => {
    get(URL.ADMIN_DASHBOARD)
      .then((res) => {
        if (res?.status == "success") {
          let total_sites = [];
          let total_companies = res?.company_data;
          res?.company_data?.forEach((item) => {
            total_sites = [...total_sites, ...item?.sites];
          });
          setDashboardList({
            ...res?.dashboard_datas,
            total_companies: total_companies,
            total_sites: total_sites,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getDashboard();
  }, []);
  console.log("dashboard list", dashboardList);

  // Styling constants
  const primaryColor = "#852e59";
  const cardShadow = "0 8px 20px rgba(0, 0, 0, 0.05)";
  const cardHoverShadow = "0 12px 28px rgba(0, 0, 0, 0.1)";
  const borderRadius = "20px";

  return (
    <div
      className="dashRightView"
      style={{ backgroundColor: "#ffffff", minHeight: "100vh" }}
    >
      {/* Stats Cards Section */}
      <div className="d-flex flex-row flex-wrap gap-4 mt-3 pointer">
        {/* No of Admin */}
        <div
          onClick={() => navigationHandler("/admin-list")}
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
                letterSpacing: "0.3px",
              }}
            >
              No of Admin
            </h4>
            <PeopleIcon style={{ color: primaryColor, fontSize: "28px" }} />
          </div>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "12px 0 0 0",
            }}
          >
            {dashboardList?.company_admin_count}
          </h2>
        </div>

        {/* No of Company */}
        <div
          onClick={() => handleNavigate(2)}
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              No of Company
            </h4>
            <BusinessIcon style={{ color: "#ff8c42", fontSize: "28px" }} />
          </div>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "12px 0 0 0",
            }}
          >
            {dashboardList?.company_count}
          </h2>
        </div>

        {/* No of Sites */}
        <div
          onClick={() => {
            setSiteList({
              name: "Site List",
              list: dashboardList?.total_sites,
            });
            handleNavigate(3);
          }}
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              No of Sites
            </h4>
            <LocationOnIcon style={{ color: "#4c9aff", fontSize: "28px" }} />
          </div>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "12px 0 0 0",
            }}
          >
            {dashboardList?.site_count}
          </h2>
        </div>

        {/* No of Camera Devices */}
        <div
          onClick={() => {
            if (givenpermissions?.includes("CAN-List-KNF_CAMERA"))
              navigationHandler("/alert-types-camera", { tab: "camera" });
          }}
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              No of Camera Devices
            </h4>
            <VideocamIcon style={{ color: "#2d9cdb", fontSize: "28px" }} />
          </div>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "12px 0 0 0",
            }}
          >
            {dashboardList?.camera_count}
          </h2>
        </div>

        {/* No of New Alerts */}
        <div
          onClick={() =>
            navigationHandler("/Overall-notifications", { tab: 1 })
          }
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              No of New Alerts
            </h4>
            <NotificationsActiveIcon
              style={{ color: "#f9a825", fontSize: "28px" }}
            />
          </div>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "12px 0 0 0",
            }}
          >
            {dashboardList?.new_alert_count}
          </h2>
        </div>

        {/* No of Allocated Alerts */}
        <div
          onClick={() =>
            navigationHandler("/Overall-notifications", { tab: 3 })
          }
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              No of Allocated Alerts
            </h4>
            <AssignmentTurnedInIcon
              style={{ color: "#9c27b0", fontSize: "28px" }}
            />
          </div>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "12px 0 0 0",
            }}
          >
            {dashboardList?.allocated_alert_count}
          </h2>
        </div>

        {/* No of Closed Alerts */}
        <div
          onClick={() =>
            navigationHandler("/Overall-notifications", { tab: 5 })
          }
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              No of Closed Alerts
            </h4>
            <DoneAllIcon style={{ color: "#43a047", fontSize: "28px" }} />
          </div>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "12px 0 0 0",
            }}
          >
            {dashboardList?.closed_alert_count}
          </h2>
        </div>
      </div>

      {/* Companies List Section */}
      {show.company && (
        <>
          <hr className="border-t-2 border-gray-400 my-5" />
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h4
              style={{
                fontSize: "20px",
                fontWeight: 700,
                color: "#2c2c2c",
                margin: 0,
              }}
            >
              Companies List
            </h4>
            <button
              className="submit-btn"
              style={{
                minWidth: "100px",
                backgroundColor: "#f0f0f0",
                color: "#666",
                border: "none",
                padding: "8px 16px",
                borderRadius: "30px",
                fontWeight: 500,
                cursor: "pointer",
                transition: "all 0.2s",
              }}
              onClick={() => setShow(false)}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#e0e0e0";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f0f0f0";
              }}
            >
              Close
            </button>
          </div>
          <div className="d-flex flex-row flex-wrap gap-4 mt-2 pointer">
            {(dashboardList?.total_companies ?? [])?.map((item) => {
              return (
                <div
                  className="my-2"
                  key={item.id}
                  ref={companyRef}
                  tabIndex={-1}
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: borderRadius,
                    boxShadow: cardShadow,
                    padding: "20px",
                    width: "280px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    border: `1px solid #f0eef0`,
                    position: "relative",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow = cardHoverShadow;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = cardShadow;
                  }}
                  onClick={() => {
                    handleNavigate(3);
                    setSiteList({
                      name: item.company_name,
                      list: item?.sites,
                    });

                    if (item?.sites?.length === 0) {
                      toast.info("No Sites Available");
                    }
                  }}
                >
                  <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
                    <div>
                      <h4
                        style={{
                          fontSize: "16px",
                          fontWeight: 700,
                          color: "#2c2c2c",
                          margin: "0 0 4px 0",
                        }}
                      >
                        {item.company_name}
                      </h4>
                      <p style={{ fontSize: "13px", color: "#888", margin: 0 }}>
                        Code: {item.company_code}
                      </p>
                    </div>
                    <BusinessIcon
                      style={{ color: "#ff8c42", fontSize: "32px" }}
                    />
                  </div>
                  <button
                    className="submit-btn"
                    style={{
                      position: "absolute",
                      right: "16px",
                      bottom: "16px",
                      minWidth: "70px",
                      padding: "6px 12px",
                      fontSize: "12px",
                      backgroundColor: primaryColor,
                      color: "white",
                      border: "none",
                      borderRadius: "20px",
                      fontWeight: 500,
                      cursor: "pointer",
                      transition: "opacity 0.2s",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigationHandler("/admin-add-company", {
                        type: "edit",
                        data: { ...item, id: item?.company_id },
                      });
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.opacity = "0.9")
                    }
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                  >
                    <EditIcon
                      style={{ fontSize: "14px", marginRight: "4px" }}
                    />
                    View
                  </button>
                </div>
              );
            })}
          </div>
        </>
      )}

      {/* Site Details Section */}
      {show.siteDetails && (
        <>
          <hr className="border-t-2 border-gray-400 my-5" />
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h4
              style={{
                fontSize: "20px",
                fontWeight: 700,
                color: "#2c2c2c",
                margin: 0,
              }}
              tabIndex={1}
              ref={detailsRef}
            >
              {`${siteList.name} Sites`}
            </h4>
            <button
              className="submit-btn"
              style={{
                minWidth: "100px",
                backgroundColor: "#f0f0f0",
                color: "#666",
                border: "none",
                padding: "8px 16px",
                borderRadius: "30px",
                fontWeight: 500,
                cursor: "pointer",
                transition: "all 0.2s",
              }}
              onClick={() => setShow(false)}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#e0e0e0";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f0f0f0";
              }}
            >
              Close
            </button>
          </div>

          <div className="row g-4 mt-2">
            {(siteList?.list ?? []).map((item) => (
              <div className="col-12 col-sm-6 col-lg-4" key={item.id}>
                <div
                  className="bg-white rounded-4 shadow-sm border h-100 d-flex flex-column justify-content-between"
                  style={{
                    transition: "all 0.3s ease",
                    minHeight: "360px",
                    borderRadius: borderRadius,
                    boxShadow: cardShadow,
                    border: `1px solid #f0eef0`,
                    overflow: "hidden",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow = cardHoverShadow;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = cardShadow;
                  }}
                >
                  <div className="p-4" style={{ flex: 1 }}>
                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-start mb-4">
                      <div>
                        <h5
                          className="f3 fw-bold mb-1"
                          style={{
                            color: "#2c2c2c",
                            fontSize: "18px",
                            margin: "0 0 4px 0",
                          }}
                        >
                          {item.site_name}
                        </h5>
                        <p
                          className="text-muted fw-semibold mb-0"
                          style={{ fontSize: "12px", color: "#888" }}
                        >
                          Code: {item.site_code}
                        </p>
                      </div>
                      <div
                        className="rounded-3 p-2"
                        style={{
                          backgroundColor: `rgba(133, 46, 89, 0.08)`,
                        }}
                      >
                        <HomeWorkIcon
                          style={{ color: primaryColor, fontSize: "28px" }}
                        />
                      </div>
                    </div>

                    {/* Stats Grid */}
                    <div className="row g-2 mb-4">
                      <div className="col-6">
                        <div
                          className="rounded-3 p-2 text-center"
                          style={{ backgroundColor: "#f8f9fa" }}
                        >
                          <p
                            className="text-muted mb-1 small fw-semibold"
                            style={{ fontSize: "11px" }}
                          >
                            Group 1
                          </p>
                          <h5
                            className="fw-bold mb-0"
                            style={{ color: "#2c2c2c", fontSize: "18px" }}
                          >
                            {item?.statistics?.group1_users_count}
                          </h5>
                        </div>
                      </div>
                      <div className="col-6">
                        <div
                          className="rounded-3 p-2 text-center"
                          style={{ backgroundColor: "#f8f9fa" }}
                        >
                          <p
                            className="text-muted mb-1 small fw-semibold"
                            style={{ fontSize: "11px" }}
                          >
                            Group 2
                          </p>
                          <h5
                            className="fw-bold mb-0"
                            style={{ color: "#2c2c2c", fontSize: "18px" }}
                          >
                            {item?.statistics?.group2_users_count}
                          </h5>
                        </div>
                      </div>
                      <div className="col-6">
                        <div
                          className="rounded-3 p-2 text-center"
                          style={{ backgroundColor: "#f8f9fa" }}
                        >
                          <p
                            className="text-muted mb-1 small fw-semibold"
                            style={{ fontSize: "11px" }}
                          >
                            Group 3
                          </p>
                          <h5
                            className="fw-bold mb-0"
                            style={{ color: "#2c2c2c", fontSize: "18px" }}
                          >
                            {item?.statistics?.group3_users_count}
                          </h5>
                        </div>
                      </div>
                      <div className="col-6">
                        <div
                          className="rounded-3 p-2 text-center"
                          style={{ backgroundColor: "#f8f9fa" }}
                        >
                          <p
                            className="text-muted mb-1 small fw-semibold"
                            style={{ fontSize: "11px" }}
                          >
                            Cameras
                          </p>
                          <h5
                            className="fw-bold mb-0"
                            style={{ color: "#2c2c2c", fontSize: "18px" }}
                          >
                            {item?.statistics?.camera_count}
                          </h5>
                        </div>
                      </div>
                    </div>

                    {/* Alerts Section */}
                    <div className="d-flex gap-2 mb-3">
                      <div
                        className="flex-fill rounded-3 p-2 text-center"
                        style={{ backgroundColor: "#fff8e7" }}
                      >
                        <p
                          className="fw-semibold mb-1 small"
                          style={{ color: "#f9a825", fontSize: "11px" }}
                        >
                          New
                        </p>
                        <h6
                          className="fw-bold mb-0"
                          style={{ color: "#f9a825", fontSize: "14px" }}
                        >
                          {item?.statistics?.new_alert_count}
                        </h6>
                      </div>
                      <div
                        className="flex-fill rounded-3 p-2 text-center"
                        style={{ backgroundColor: "#f3e5f5" }}
                      >
                        <p
                          className="fw-semibold mb-1 small"
                          style={{ color: "#9c27b0", fontSize: "11px" }}
                        >
                          Allocated
                        </p>
                        <h6
                          className="fw-bold mb-0"
                          style={{ color: "#9c27b0", fontSize: "14px" }}
                        >
                          {item?.statistics?.allocated_alert_count}
                        </h6>
                      </div>
                      <div
                        className="flex-fill rounded-3 p-2 text-center"
                        style={{ backgroundColor: "#e8f5e9" }}
                      >
                        <p
                          className="fw-semibold mb-1 small"
                          style={{ color: "#43a047", fontSize: "11px" }}
                        >
                          Closed
                        </p>
                        <h6
                          className="fw-bold mb-0"
                          style={{ color: "#43a047", fontSize: "14px" }}
                        >
                          {item?.statistics?.closed_alert_count}
                        </h6>
                      </div>
                    </div>
                  </div>

                  {/* Button */}
                  <div className="p-3 pt-0">
                    <button
                      className="w-100"
                      style={{
                        backgroundColor: primaryColor,
                        color: "white",
                        border: "none",
                        borderRadius: "30px",
                        padding: "10px 16px",
                        fontSize: "13px",
                        fontWeight: 500,
                        cursor: "pointer",
                        transition: "opacity 0.2s",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigationHandler("/sites-view", {
                          type: "view",
                          data: { ...item, id: item?.site_id },
                        });
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.opacity = "0.9")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.opacity = "1")
                      }
                    >
                      <VisibilityIcon
                        style={{ fontSize: "14px", marginRight: "6px" }}
                      />
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SuperAdminDashboard;
